import { NotificationService } from '../services/notification.service';

/**
 * Wird als Feld in eine Komponente eingebunden (`copyToClipboard = copyToClipboard`). Der
 * this-Parameter erzwingt, dass sie den NotificationService injiziert.
 */
export function copyToClipboard(
  this: { notificationService: NotificationService },
  text: string,
) {
  navigator.clipboard.writeText(text).then(
    () => {
      this.notificationService.success('In die Zwischenablage kopiert!', text);
    },
    () => {
      this.notificationService.error(
        'Fehler beim Kopieren in die Zwischenablage.',
      );
    },
  );
}
